import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SocketIoService } from '../socket-io.service';
import { StreamAddConsumerResponseDto } from './dtos/stream-add-consumer.response.dto';
import { StreamConnectConsumerRequestDto } from './dtos/stream-connect-consumer.request.dto';
import { StreamConnectProducerRequestDto } from './dtos/stream-connect-producer.request.dto';
import { StreamConsumeRequestDto } from './dtos/stream-consume.request.dto';
import { StreamConsumeResponseDto } from './dtos/stream-consume.response.dto';
import { StreamCreateRoomRequestDto } from './dtos/stream-create-room.request.dto';
import { StreamProduceRequestDto } from './dtos/stream-produce.request.dto';
import { StreamProduceResponseDto } from './dtos/stream-produce.response.dto';
import { StreamProducerReadyRequestDto } from './dtos/stream-producer-ready.request.dto';
import { StreamProducerReadyResponseDto } from './dtos/stream-producer-ready.response.dto';
import { StreamRoomDto } from './dtos/stream-room.dto';

@Injectable({ providedIn: 'root' })
export class DeviceStreamApiService {
  constructor(private readonly socketIo: SocketIoService) {}

  public get currentParticipantId(): string | null {
    return this.socketIo.getSocketId();
  }

  public createRoom(request: StreamCreateRoomRequestDto): Observable<StreamRoomDto> {
    return this.socketIo.sendWithAck<StreamRoomDto>('stream:create-room', request);
  }

  public addConsumer(roomId: string): Observable<StreamAddConsumerResponseDto> {
    return this.socketIo.sendWithAck<StreamAddConsumerResponseDto>('stream:add-consumer', { roomId });
  }

  public connectConsumer(request: StreamConnectConsumerRequestDto): Observable<void> {
    return this.socketIo.sendWithAck<void>('stream:connect-consumer', request);
  }

  public consume(request: StreamConsumeRequestDto): Observable<StreamConsumeResponseDto> {
    return this.socketIo.sendWithAck<StreamConsumeResponseDto>('stream:consume', request);
  }

  public disconnectConsumer(roomId: string): Observable<void> {
    return this.socketIo.sendWithAck<void>('stream:disconnect-consumer', { roomId });
  }

  public connectProducer(request: StreamConnectProducerRequestDto): Observable<void> {
    return this.socketIo.sendWithAck<void>('stream:connect-producer', request);
  }

  public produce(request: StreamProduceRequestDto): Observable<StreamProduceResponseDto> {
    return this.socketIo.sendWithAck<StreamProduceResponseDto>('stream:produce', request);
  }

  public disconnectProducer(roomId: string): Observable<void> {
    return this.socketIo.sendWithAck<void>('stream:disconnect-producer', { roomId });
  }

  public closeRoom(roomId: string): Observable<void> {
    return this.socketIo.sendWithAck<void>('stream:close-room', { roomId });
  }

  public producerReady(request: StreamProducerReadyRequestDto): Observable<StreamProducerReadyResponseDto> {
    return this.socketIo.sendWithAck<StreamProducerReadyResponseDto>('stream:producer-ready', request);
  }
}
